import React from "react";

import { Row, Col, RSelect, Button } from "../Component";
import { OLYMPIAD_TYPE_OPTIONS } from "../../utilities/constants";

const OlympiadPageFilters = ({
  createdDateFrom,
  setCreatedDateFrom,
  createdDateTo,
  setCreatedDateTo,
  region,
  setRegion,
  olympiadType,
  setOlympiadType,
  onClearAllFilters,
}) => {
  return (
    <div className="card card-inner mb-3">
      <div className="card-body">
        <Row className="g-3 align-items-end">
          <Col md="2">
            <label className="form-label">Created from</label>
            <input
              type="date"
              className="form-control"
              value={createdDateFrom}
              onChange={(e) => setCreatedDateFrom(e.target.value)}
            />
          </Col>
          <Col md="2">
            <label className="form-label">Created to</label>
            <input
              type="date"
              className="form-control"
              value={createdDateTo}
              onChange={(e) => setCreatedDateTo(e.target.value)}
            />
          </Col>
          <Col md="3">
            <label className="form-label">Region</label>
            <input
              type="text"
              className="form-control"
              placeholder="Region"
              value={region}
              onChange={(e) => setRegion(e.target.value)}
            />
          </Col>
          <Col md="3">
            <label className="form-label">Olympiad type</label>
            <RSelect
              placeholder="Select olympiad type"
              options={OLYMPIAD_TYPE_OPTIONS}
              value={olympiadType}
              onChange={setOlympiadType}
              isClearable
            />
          </Col>
          {onClearAllFilters && (
            <Col md="1">
              <Button
                type="button"
                color="info"
                className="btn-icon"
                iconName="reload"
                aria-label="Clear filters"
                onClick={onClearAllFilters}
              />
            </Col>
          )}
        </Row>
      </div>
    </div>
  );
};

export default OlympiadPageFilters;
